import React from 'react';
import PropTypes from 'prop-types';
import { connect as reduxConnect } from 'react-redux';
import emitter from '../../emitter';
import tacHelpers from '../../state/tac/tacHelpers';
import productService from '../../services/products';
import { CONF_MENU_CHANGE } from '../../settings/events';
import { range } from './range';
import { selectUseMetric } from '../../state/dexfSettings/dexfSettingsSelectors';
import { ITEMS } from '../../constants';
import { selectTac } from '../../state/tac/tacSelectors';
import {
  thunkAddItem,
  thunkRemoveItem,
  thunkUpdateItem,
  thunkUpdateMultiple,
} from '../../state/tac/tacThunks';

export default class AbstractPicker extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    tac: PropTypes.object.isRequired,
  };

  switch({ from, to, switchingProp, moveOthers = false, targetType }) {
    const { tac } = this.props;
    const superSection = tacHelpers.findSuperSection(tac, from);
    if (to.moveDirection && superSection && superSection.length > 1) {
      const itemsToUpdate = range.moveSuperSection(from, superSection, to);
      if (itemsToUpdate.length) {
        this.props.dispatch(
          thunkUpdateMultiple(itemsToUpdate, tac, {
            origin: 'dialog',
            optionType: to.type,
            optionValue: to.value,
            moveOthers: false,
            priorityItem: from,
            hasDependencies: true,
          })
        );
      }
      emitter.emit(CONF_MENU_CHANGE);
    } else {
      const parent = tacHelpers.getParent(tac, from);
      const slotSources =
        tacHelpers.range.getSlotSources?.({ ...from, id: to.id }, tac) || [];
      const newItem = tacHelpers.getSwitchableItem(from, to, {
        switchingProp,
        slotSources,
        targetType,
      });
      if (
        targetType === ITEMS.SECTION &&
        tacHelpers.range.isIncompleteSection(newItem)
      ) {
        const neighbours = tacHelpers.range.getNeighbouringSections(
          tac,
          newItem
        );

        this.props.dispatch(
          thunkUpdateMultiple([newItem, ...neighbours], tac, {
            origin: 'dialog',
            optionType: to.type,
            optionValue: to.value,
            moveOthers,
            forcePartsOnFirstItem: true,
            triggerItem: newItem,
          })
        );
      } else {
        this.props.dispatch(
          thunkUpdateItem(newItem, parent, {
            origin: 'dialog',
            optionType: to.type,
            optionValue: to.value,
            moveOthers,
          })
        );
      }
      emitter.emit(CONF_MENU_CHANGE);
    }
  }

  add(parent, slot, childId) {
    const product = productService.getProduct(childId);
    const offset = tacHelpers.getGlobalCoords(slot.parent, this.props.tac) || {
      x: 0,
      y: 0,
      z: 0,
    };

    const newItem = {
      ...product,
      x: slot.x - offset.x,
      y: slot.y - offset.y,
      z: slot.z - offset.z,
    };

    this.props.dispatch(
      thunkAddItem(newItem, parent, {
        origin: 'dialog',
        optionType: newItem.type,
      })
    );
    emitter.emit(CONF_MENU_CHANGE);
  }

  removeChildren(parent, type) {
    parent.items &&
      parent.items
        .filter(child => child.type === type)
        .forEach(item => {
          this.props.dispatch(
            thunkRemoveItem(item, undefined, {
              origin: 'dialog',
              optionType: type,
            })
          );
          emitter.emit(CONF_MENU_CHANGE);
        });
  }

  isSelected(option, selected, filterProp) {
    if (option.id === selected.id && option.modelid === selected.modelid) {
      return true;
    }
    if (
      !selected.hasDivergentItems &&
      option.value === selected.filter[filterProp]
    ) {
      return true;
    }

    return false;
  }
}

export const connect = reduxConnect(state => ({
  tac: selectTac(state),
  useMetricMeasures: selectUseMetric(state),
}));
